import Axios from 'axios';

export default {
  getStudentBillings(studentId) {
    return Axios.get('/admin/billings', {
      params: {
        student_id: studentId,
      },
    })
      .then(({ data }) => data);
  },

  loadInterruptionReasons() {
    return Axios.get('/admin/enums/billings/interruption-reasons');
  },

  cancelBilling(billingId, observations) {
    return Axios.put(`/admin/billings/${billingId}/cancel`, { observations })
      .then(({ data }) => data);
  },

  interruptBilling(billingId, observations, interruptionReasonKey, selectOptionDebt, ipcaValue, debtDueDate) {
    return Axios.put(`/admin/billings/${billingId}/interrupt`, {
      observations,
      interruption_reason_key: interruptionReasonKey,
      has_debts: selectOptionDebt,
      ipca_percentage: ipcaValue,
      debt_due_date: debtDueDate,
    })
      .then(({ data }) => data);
  },

  changeDueDay(billingId, newDueDay) {
    return Axios.put(`/admin/billings/${billingId}/change-due-day`, {
      new_due_day: newDueDay,
    })
      .then(({ data }) => data);
  },

  updateFcvBillingWithJacad(billingId) {
    return Axios.put(`/admin/billings/${billingId}/update-fcv-billing-with-jacad`);
  },

  updateBillingsWithJacadInBatch(billingIds) {
    return Axios.put('/admin/billings/update-billings-with-jacad-in-batch',
      { billing_ids: billingIds });
  },

  reactivateBilling(billingId, observations) {
    return Axios.put(`/admin/billings/${billingId}/reactivate`, { observations })
      .then(({ data }) => data);
  },

  billingValueChange(billingId, params) {
    return Axios.put(`/admin/billings/${billingId}/update-billing-value`, params)
      .then(({ data }) => data);
  },

  updateBillingExternalId(billingId, newBillingExternalId) {
    return Axios.put(`/admin/billings/${billingId}/update-external-id`, { external_id: newBillingExternalId })
      .then(({ data }) => data);
  },

  updateBillingCourse(billingId, newBillingCourse) {
    return Axios.put(`/admin/billings/${billingId}/update-billing-course`, newBillingCourse)
      .then(({ data }) => data);
  },
};
